import { createAction } from "../creators";

export default {
  ...createAction("SUBSCRIBE", "payload"),
  ...createAction("SUBSCRIBE_COMPLETE", "data"),
};
